import { render, staticRenderFns } from "./update-address.component.vue?vue&type=template&id=7977f4ba&"
import script from "./update-address.component.vue?vue&type=script&lang=ts&"
export * from "./update-address.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports